<template>
    <div class="People">
        <div class="row">
            <div class="col">
                <h4>Owners of Relationship:</h4>
                <SingleMembershipEditor :fields="[{name: 'Employee.Person.FullName', title: 'NAME'}, {name: 'StartDate', title: 'START', callback: 'formatDate|MM/DD/YY'}, {name: 'EndDate', title: 'END', callback: 'formatDate|MM/DD/YY|N/A'}]"
                                        :field-data="ChurchRecordData.OwnersOfRelationship"
                                        :edit-mode="EditMode"
                                        select-label="Employee:"
                                        options-type="API"
                                        options-method="ChurchEngagement.Churches.People.GetAvailableOwnersOfRelationship"
                                        :options-method-record-id="ChurchRecordData.Church.Id"
                                        add-record-method="ChurchEngagement.Churches.People.AddChurchRelationshipOwner"
                                        add-record-record-property-name="EmployeeID"
                                        :add-record-additional-payload="{ChurchID: ChurchRecordData.Church.Id}"
                                        add-record-modal-title="Add Owner of Relationship"
                                        transfer-record-method="ChurchEngagement.Churches.People.AddChurchRelationshipOwner"
                                        transfer-record-record-property-name="EmployeeID"
                                        :transfer-record-additional-payload="{ChurchID: ChurchRecordData.Church.Id}"
                                        transfer-record-modal-title="Transfer Owner of Relationship"
                                        transfer-record-effective-date-property-name="StartDate"
                                        delete-record-method="ChurchEngagement.Churches.People.DeleteCurrentChurchRelationshipOwner"
                                        :delete-record-additional-payload="{Id: ChurchRecordData.Church.Id}"
                                        delete-record-modal-title="Remove Current Relationship Owner"
                                        delete-record-modal-text="NOTICE: You are about to remove this church's current relationship owner.  If there was a previous owner, it will re-assign to the previous owner." />
            </div>


        </div>
        <div class="row">
            <div class="col">
                <h4>Main Contacts:</h4>
                <MainContactEditor :field-data="ChurchRecordData.MainContacts"
                                   :edit-mode="EditMode"
                                   :record-id="ChurchRecordData.Church.Id" />
            </div>


        </div>
        <div class="row">
            <div class="col">
                <h4>Ministry Leads:</h4>
                <MinistryLeadEditor :field-data="ChurchRecordData.MinistryLeads"
                                   :edit-mode="EditMode"
                                   :record-id="ChurchRecordData.Church.Id" />
            </div>


        </div>

        <div class="row">
            <div class="col padding-top-md pointer" v-on:click="ToggleEditMode()">
                <font-awesome-icon :icon="['fa', 'edit']" />
                <span v-if="EditMode"> Edit Mode: ON</span>
                <span v-else> Edit Mode: OFF</span>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import SingleMembershipEditor from '../../../Core/ItemEditors/SingleMembershipEditor';
    import MainContactEditor from './MainContactEditor.vue';
    import MinistryLeadEditor from './MinistryLeadEditor.vue';

    export default {
        props: [
            'ChurchRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            ToggleEditMode() {
                this.EditMode = !this.EditMode;
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            }
        },
        components: {
            SingleMembershipEditor,
            MainContactEditor,
            MinistryLeadEditor
        },
        mounted() {

        },
        computed: {
            
        }    
    }
</script>

<style scoped>
</style>